import { U1StatusProps } from './Status.consts';
import { StyledHiddenText } from './Status.styles';

export const U1Status: React.FC<U1StatusProps> = ({ srMessage }: U1StatusProps) => {
  return srMessage && <StyledHiddenText data-u1-status="true">{srMessage}</StyledHiddenText>;
};
